export const FontSizeXSmall = 12;
export const FontSizeSmall = 14;
export const FontSizeNormal = 16;
export const FontSizeLarge = 18;
export const FontSizeXLarge = 20;
export const FontSizeXXLarge = 24;
export const FontSizeXXXLarge = 28;
